/* eslint-disable react/prop-types */

import React from "react";
import { PropTypes } from "prop-types";
import { graphql, Link } from "gatsby";
import Button from "~components/Button";
import Layout from "~components/Layout";
import SEO from "~components/SEO";
import TyperSection from "~components/TyperSection";
import { splitStringToParagraphs } from "~utils/helpers";

const ExperimentsPage = ({ data, location }) => {
  const { frontmatter } = data.markdownRemark;

  //

  return (
    <>
      <SEO
        customTitle={frontmatter.title}
        customDescription={frontmatter.seoDescription}
        customKeywords={frontmatter.seoKeywords}
        path={location.pathname}
      />

      <Layout className="experiments-page w-full relative bg-white text-orange">
        <TyperSection
          heading={frontmatter.heading}
          colour="sauvignon"
          backgroundColour="orange"
          imageText={frontmatter.imageText}
          imageTextColour="orange"
          imageCaption={frontmatter.imageCaption}
          imageColor="sauvignon"
          typerColor="orange"
          location={location}
        />
        <section className="">
          <div className="grid pt-v7 xs:py-v14 pb-v7">
            <article className="grid-end-6 xs:grid-end-8">
              {splitStringToParagraphs(
                frontmatter.clientsIntro,
                `mb-v2 xs:mb-v10 b1 universal-sans`
              )}
            </article>
          </div>
        </section>
        <section className="">
          {frontmatter?.clients?.[0] &&
            frontmatter.clients.map((client, clientIndex) => (
              <div key={client} className="grid pt-v1 mb-v6">
                <h3 className="grid-end-6 xs:grid-end-2 xs:mb-v3 xs:mt-v2 f3 universal-sans">{`${
                  frontmatter.clients.length <= 10 ? 0 : ``
                }${clientIndex + 1}`}</h3>

                <div className="grid-end-6 xs:grid-end-6 xs:mt-v2 xs:mb-v5">
                  <p className="f3 universal-sans">{client.content}</p>
                </div>
              </div>
            ))}
        </section>

        <section className="grid">
          <p className="grid-end-6 xs:grid-end-8 b1 universal-sans mt-v1 xs:mt-v10">
            {frontmatter.clientsFootnote}
          </p>
        </section>

        <section className="grid">
          <div className="grid-end-12 xs:grid-end-8 flex justify-center my-v7 xs:my-v14">
            <Link to="/work">
              <Button className="" color="orange" text="See our work" filled />
            </Link>
          </div>
        </section>
      </Layout>
    </>
  );
};

ExperimentsPage.propTypes = {
  data: PropTypes.shape({
    markdownRemark: PropTypes.shape({
      frontmatter: PropTypes.shape({})
    })
  }).isRequired,
  location: PropTypes.shape({}).isRequired
};

export default ExperimentsPage;

export const query = graphql`
  query ExperimentsPage($id: String!) {
    markdownRemark(id: { eq: $id }) {
      frontmatter {
        title
        heading
        imageText
        imageCaption
        clientsIntro
        clients {
          content
        }
        clientsFootnote
        creativesIntro
        seoDescription
        seoKeywords
      }
    }
  }
`;
